import GlobalSearchPanes from './GlobalSearchPanes'

// Body for a Global Search grid window. Renders the results|viewer split once the
// chat is available (fetched/cached by the page), or a loading placeholder while
// a persisted window rehydrates on reload. The "no chat loaded" case is handled
// by the page (empty window -> a select/create prompt), matching Searchrooms/Code.
function GlobalSearchWindowBody({ chat, panes, onPanesChange }) {
  if (!chat) {
    return <div className="display-empty">Loading chat…</div>
  }
  return <GlobalSearchPanes chat={chat} panes={panes} onPanesChange={onPanesChange} />
}

export default GlobalSearchWindowBody
